export default () => {
  const copyButton = document.getElementById("copy");
  if (copyButton) {
    copyButton.addEventListener("click", function () {
      var copyText = document.getElementById("copy");
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.getAttribute("data-text"));
      copyText.innerHTML = "Copied!";
      setTimeout(function () {
        copyText.innerHTML = "Copy";
      }, 3000);
    });
  }
};
